/**
 * What the server's check said about a stage, or about the whole workflow.
 * The tones are the kit's (`TONE_TINT`, `TONE_BORDER`) — never a palette
 * colour written here (C14 §10.6 item 4).
 */

import { TONE_BORDER, TONE_TINT } from '@fiveox/ui'

import type { Issue } from '../../lib/api/services'

export function IssueList({ issues, tone }: { issues: Issue[]; tone: 'error' | 'warning' }) {
  if (issues.length === 0) return null
  return (
    <ul
      data-issues={tone}
      className={`space-y-1 rounded-lg border p-2.5 text-xs ${TONE_TINT[tone]} ${TONE_BORDER[tone]}`}
    >
      {issues.map((issue, i) => (
        <li key={i}>{issue.message}</li>
      ))}
    </ul>
  )
}
